import React, { PureComponent } from 'react';
import withStyles from 'components/@layout/withStyles';
import ResourceItem from '../ResourceItem/ResourceItem';
import { remCalc } from '../../../util/style-util';
import { LiteResource, Resource } from 'types';
import { FONT_GSS_FUTURA } from 'themes/default';

type Props = {
  resourcesItems: Resource[];
  isFavoritePage?: boolean;
  onSelectItem: (resource: LiteResource) => void;
  onClickPinIcon?: (resource: Resource) => void;
  onRemoveItem?: (resource: Resource) => void;
  classes?: any;
};

class ResourcesList extends PureComponent<Props> {
  renderResourcesItems() {
    this.props.resourcesItems.sort((resourceA, resourceB) => {
      const titleA = resourceA.title.toUpperCase();
      const titleB = resourceB.title.toUpperCase();
      return titleA < titleB ? -1 : titleA > titleB ? 1 : 0;
    });
    const resourceItems: Array<React.ReactElement<any>> = this.props.resourcesItems.map(
      (item: Resource, index: number) => {
        const resource: LiteResource = {
          id: item.id ? item.id : 0,
          title: item?.title,
          type: item?.type?.type,
          mediaType: item.data.mediaType,
          url: item.url,
          aspectRatio: item.data.aspectRatio,
          heightAdjust: item.data.heightAdjust,
          fileExtension: item.data.fileExtension,
          resourceTypeId: item.data.resourceTypeId,
          data: item.data
        };

        return (
          <li key={index}>
            <ResourceItem
              tabIndex={0}
              resource={item}
              hasUnpinIcon={item.favorites && item.favorites.length > 0}
              isFavoritePage={this.props.isFavoritePage}
              onClick={() => this.props.onSelectItem(resource)}
              onClickPinIcon={this.props.onClickPinIcon}
              onRemoveItem={this.props.onRemoveItem}
            />
          </li>
        );
      }
    );
    return resourceItems;
  }

  render() {
    const { resourcesList, gridLayout } = this.props.classes;
    return <ul className={`${resourcesList} ${gridLayout}`}>{this.renderResourcesItems()}</ul>;
  }
}

const screenSize = {
  smartphone: '@media only screen and (max-width: 499px)',
  smartphoneLandscape: '@media only screen and (min-width: 500px) and (max-width: 799px)',
  tablet: '@media only screen and (min-width: 800px) and (max-width: 1199px)',
  desktop: '@media only screen and (min-width: 1200px) and (max-width: 1699px)',
  wideScreen: '@media only screen and (min-width: 1700px)'
};

const styles = {
  resourcesList: {
    fontFamily: FONT_GSS_FUTURA,
    padding: remCalc(19.2)
  },
  gridLayout: {
    display: 'grid',
    gridAutoFlow: 'row',
    gridGap: '30px 30px',
    justifyContent: 'center',
    listStyle: 'none',
    [screenSize.smartphone]: {
      gridTemplateColumns: '1fr'
    },
    [screenSize.smartphoneLandscape]: {
      gridTemplateColumns: '1fr'
    },
    [screenSize.tablet]: {
      gridTemplateColumns: '1fr 1fr'
    },
    [screenSize.desktop]: {
      gridTemplateColumns: '1fr 1fr 1fr'
    },
    [screenSize.wideScreen]: {
      gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr'
    }
  }
};

export default withStyles(styles)(ResourcesList) as any;
